import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import { extractQueryParams } from '../../../lib/extract-query-params'

import { fetchAuthToken } from '../../../redux/auth'
import { addGlobalError } from '../../../redux/error'

class AuthLoadingScreen extends PureComponent {
  componentDidMount () {
    const params = extractQueryParams()
    this.props.fetchAuthToken(this.props.navigation, params)
  }

  render () {
    return <CenteredSpinner />
  }
}

const mapStateToProps = (state) => {
  return {
    eventId: state.auth.eventId,
    environment: state.auth.environment
  }
}

export default connect(mapStateToProps, {
  fetchAuthToken,
  addGlobalError
})(AuthLoadingScreen)
